import { render, staticRenderFns } from "./incomeStatementTable.vue?vue&type=template&id=0587e60f&"
import script from "./incomeStatementTable.vue?vue&type=script&lang=js&"
export * from "./incomeStatementTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports